// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1Mt_Y","rootSmall":"AddTileButton_rootSmall__v1jOy"};